// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  dialog: {
    minWidth: '600px',
    margin: 'auto',
  },
  // One row: icon, message, Close; the message is capped so a long sentence wraps evenly instead of running under the button
  dialogBox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2, 3),
  },
  message: {
    maxWidth: theme.spacing(48),
  },
  icon: {
    flexShrink: 0,
  },
  closeButton: {
    flexShrink: 0,
    marginLeft: theme.spacing(1),
  },
});

export default styles;
